<section class="service-banner">
	<div class="container">
		<div class="row">
			<div class="col-xl-11 m-auto">
				<div class="vh-100">
					<div
						class="d-flex flex-column justify-content-center align-items-center h-100"
					>
						<div class="block-content">
							<div class="d-flex flex-row w-100">
								<h1
									*ngIf="!success"
									class="d-none d-sm-block d-md-block d-lg-block d-xl-block d-xxl-block"
									data-aos="fade-up"
									data-aos-duration="1000"
									data-aos-delay="100"
								>
									Do you want to {{ type | titlecase }} Subscriptions?
								</h1>
								<h1
									*ngIf="success"
									class="d-none d-sm-block d-md-block d-lg-block d-xl-block d-xxl-block"
									data-aos="fade-up"
									data-aos-duration="1000"
									data-aos-delay="100"
								>
									Your subscription has been successfully
									{{ type | titlecase }}.
								</h1>
							</div>
							<p *ngIf="success">
								If you have any questions or need further assistance, feel free
								to contact our support team.
							</p>
							<!-- <p>Please check your email for login details.</p> -->
							<div class="position-absolute start-50 down-arrow">
								<p class="mb-4">
									<a href="/" class="cstbtn">
										<span class="text"> Back to Home</span>
										<span class="borderspan"
											><!--<i class="fa fa-chevron-right" aria-hidden="true"></i> -->
											<lucide-icon
												name="chevron-right"
												class="lucide-arrow-icon"
											></lucide-icon>
										</span>
									</a>
								</p>
							</div>
							<!-- mobile -->
							<h1
								*ngIf="!success"
								class="d-block d-sm-none d-md-none d-lg-none d-xl-none d-xxl-none"
								data-aos="fade-up"
								data-aos-duration="1000"
								data-aos-delay="100"
							>
								Do you want to {{ type | titlecase }} Subscriptions?
							</h1>
							<h1
								*ngIf="success"
								class="d-block d-sm-none d-md-none d-lg-none d-xl-none d-xxl-none"
								data-aos="fade-up"
								data-aos-duration="1000"
								data-aos-delay="100"
							>
								Your subscription has been successfully {{ type | titlecase }}.
							</h1>
							<!-- <h1 class="csm d-block d-sm-none d-md-none d-lg-none d-xl-none d-xxl-none" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200"> Successfull</h1> -->
							<!-- mobile -->
						</div>
					</div>
					<p
						class="p32 head position-relative w-100 start-0 end-0 d-block d-sm-none d-md-none d-lg-none d-xl-none d-xxl-none"
						data-aos="fade-up"
						data-aos-duration="1000"
						data-aos-delay="100"
					>
						We do it real
					</p>
				</div>
			</div>
		</div>
	</div>
</section>
